/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { G as index$f } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import getLocation$3 from './cnStation/index.js';
import getLocation$1 from './browser/index.js';
import getLocation$2 from './dingTalk/index.js';
import getLocation$4 from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        browser: getLocation$1,
        dingTalk: getLocation$2,
        dingTalkPC: getLocation$1,
        windvane: {
            cnStation: getLocation$3,
        },
    },
    // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
    mini: mini,
    panguMiniApp: getLocation$4,
};
/**
 * 获取地理位置，此 API 只返回经纬度，如需街道信息，请自行调用 mtop.taobao.wireless.lbs.regeo.getAddress 解析
 * API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @returns {Promise<{latitude: string; longitude: string}>} promise调用结果
 *
 * @example
 * import { getLocation } from '@alife/cn-uni-api';
 *
 * getLocation().then((res) => {
 *   console.log('success', res.latitude, res.longitude);
 * }).catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var getLocation = extend(apiConfig, index$f);

export { getLocation };
